import BackofficeInterceptor from '../BackofficeInterceptor'

const api = new BackofficeInterceptor()

export default {
  addNegociacao(headers: any) {
    return api.post(`/medicos/${headers.medicoId}/negociacao/local-execucao/${headers.localExecucaoId}/quem-paga/${headers.fontePagadora}`, headers.negociacao)
  },

  deleteNegociacao(headers: any) {
    return api.delete(`/medicos/${headers.medicoId}/negociacao/${headers.negociacaoId}`)
  },

  getNegociacoesByLocalExecucao(medicoId) {
    return api.get(`medicos/${medicoId}/negociacao/local-execucao`)
  },

  getNegociacaoById(headers: any) {
    return api.get(`/medicos/${headers.medicoId}/negociacao/${headers.negociacaoId}`)
  },

  getNegociacaoFontePagadora(medicoId, localExecucaoId, fontePagadora) {
    return api.get(`/medicos/${medicoId}/negociacao/local-execucao/${localExecucaoId}/quem-paga/${fontePagadora}`)
  },

  saveProcedimentos(negociacaoId: Number, procedimentos: Array<any>) {
    return api.post(`/negociacao/${negociacaoId}/procedimentos`, procedimentos)
  },
}
